import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/client';
import { registerSessionReset } from '@/stores/session-reset';

/**
 * Bộ nhớ đệm của mọi dữ liệu nạp riêng theo màn hình (doanh thu, kho nhạc…). Là MỘT đối tượng dùng
 * chung để cả phần không phải component (hàng đợi đưa nhạc lên) cũng làm mới được dữ liệu.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Lỗi 4xx là câu trả lời dứt khoát của máy chủ — thử lại chỉ tốn thêm một lượt gọi.
      retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
    },
  },
});

// Phiên kết thúc (đăng xuất HAY hết hạn) là xoá sạch: dữ liệu đệm sống thêm 5 phút sau khi màn hình
// đóng, nên người đăng nhập kế tiếp trên cùng máy sẽ thấy doanh thu / nhạc của người trước.
registerSessionReset(() => queryClient.clear());
